import React, { useEffect, useState, useCallback } from 'react';
import { Typography, Box } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import WithdrawMoneyCard from './Transactions/WithdrawMoneyCard';
import TransactionsHistory from './Transactions/TransactionHistory';
import baseURL from '../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from '../../../Reusable/PageLoader';

const Transactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [balance, setBalance] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchTransactionData = useCallback(async () => {
        setLoading(true);
        try {
            // await new Promise(resolve => setTimeout(resolve, 4000));

            const [transactionsResponse, statsResponse] = await Promise.all([
                fetch(`${baseURL}/user/transactions`, { credentials: "include" }),
                fetch(`${baseURL}/user/dashboard-stats`, { credentials: "include" }),
            ]);

            const [transactionsData, statsData] = await Promise.all([
                transactionsResponse.json(),
                statsResponse.json(),
            ]);

            if (!transactionsResponse.ok) throw new Error(transactionsData.message || "Failed to load transactions.");
            if (!statsResponse.ok) throw new Error(statsData.message || "Failed to load stats.");

            setTransactions(transactionsData || []);
            setBalance(statsData.user_balance || 0);
            setPhoneNumber(statsData.phone || null);
        } catch (err) {
            console.error("Error fetching transaction data:", err);
            toast.error(err.message || "Failed to load transactions and balance.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTransactionData();
    }, [fetchTransactionData]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* Loader inside layout */}

            {!loading && (
                <>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#666',
                            marginBottom: 2,
                            textAlign: 'left',
                            marginTop: 2,
                            fontWeight: '600',
                        }}
                    >
                        Manage Transactions
                    </Typography>

                    <TransactionsHistory transactions={transactions} />
                    <WithdrawMoneyCard 
                        balance={balance} 
                        phoneNumber={phoneNumber}
                        onWithdrawalCompleted={fetchTransactionData} 
                    />
                </>
            )}
        </DashboardLayout>
    );
};

export default Transactions;
